export default function() {
  var events = new Vue({
    el: 'main',
    data: {
      filter: []
    },
    created: function () {
      var that = this;
      $('.events-filter-container input:checked').each(function(){
        that.filter.push($(this).data('id'));
      });
    },
    methods: {
      updateFilter: function(){
        var that = this;
        that.filter = [];
        $('.events-filter-container input:checked').each(function(){
          that.filter.push($(this).data('id'));
        });
      },
      isInFilter : function(cat){
        for(var i=0; i < this.filter.length; i++){
          if( $.inArray( cat, this.filter) >= 0 ){
            return true;
          }
        }
        return false;
      }
    }
  });
}


// WEBPACK FOOTER //
// app/javascript/src/javascripts/page/events.js